import React from 'react';
import styles from './styles.module.scss';
import {Button, Modal} from "../../index";
import ContactForm from "../../forms/ContactForm";
import {useStore} from "../../../hooks";
import { useFormModal } from "../../../hooks/useFormModal";
import PhoneIcon from "@/images/icons/phone.svg";
import EmailIcon from "@/images/icons/email.svg";
import cc from "classcat";

interface Props {
    shortText: string;
    title: string;
    formTitle: string,
    backgroundImage: string;
}

const SalesFormCta = ({ shortText, title, formTitle, backgroundImage }: Props) => {
    const { isOpen: enquireModal, openModal, closeModal } = useFormModal(['enquireForm', 'contactForm']);
    const globals = useStore('globals');

    return (
        <div className={cc([
            'sectionWrapper section-purple',
            styles.ctaWrapper,
            backgroundImage && styles.backgroundImagePresent
        ])}>
            {backgroundImage && (
                <div className={styles.backgroundImage}>
                    <img src={backgroundImage} alt={title} />
                </div>
            )}
            <div className="container">
                <div className={styles.ctaContainer}>
                    <div className={styles.ctaText}>
                        {title && (
                            <h3>
                                {title}
                            </h3>
                        )}

                        {shortText && (
                            <p>
                                {shortText}
                            </p>
                        )}
                    </div>

                    <div className={styles.ctaButtons}>
                        <Button onClick={openModal} large type="solidOrange" className={'newStyleButtonOverrideSolid'}>
                            <EmailIcon />
                            Send an email
                        </Button>

                        <Button href={`tel:${globals.phone}`} large type="orangeBorder" className={'newStyleButtonOverrideSolid'}>
                            <PhoneIcon />
                            {globals.phone}
                        </Button>
                    </div>
                </div>
            </div>

            <Modal isOpen={enquireModal} onRequestClose={closeModal} title={formTitle}>
                <ContactForm section={'Sales Form'} title={formTitle}/>
            </Modal>
        </div>
    );
};

export default SalesFormCta;
